<template>
    <div class="routerContent">
        <div class="card df p10">
            <!-- <el-button type="primary" @click="editData()">新增</el-button>
            <el-button type="primary" @click="batchDelete()">批量删除</el-button> -->
            <div class="fg1"></div>
            <el-input class="topSearch" placeholder="请输入申请人" clearable v-model="searchForm.applyUserName"
                      style="width: 300px; height: 30px">
                <el-button slot="append" icon="el-icon-search" @click="initData"></el-button>
            </el-input>
            <el-button icon="el-icon-s-operation" class="ml10" @click="showForm = !showForm" style="font-size: 14px"
                       type="text">高级搜索
            </el-button>
        </div>
        <pageDialog class="card" v-model="showForm">
            <el-form :model="searchForm" label-width="70px"  label-position="top" ref="searchForm">
                <el-form-item label="标签样式">
                    <enuSelect style="width:100%;" filterable v-model="searchForm.tagYs" :list='bqysList' placeholder="请选择标签样式"></enuSelect>
                </el-form-item>
                <el-form-item label="标签规格">
                    <enuSelect style="width:100%;" filterable v-model="searchForm.tagGg" :list='bqggList' placeholder="请选择标签规格"></enuSelect>
                </el-form-item>
                <el-form-item label="状态">
                    <enuSelect style="width:100%;" filterable v-model="searchForm.tagZt" :list='bqztList' placeholder="请选择标签状态"></enuSelect>
                </el-form-item>
            </el-form>
            <div class="df jce" slot="footer">
                <el-button @click="reset">重置</el-button>
                <el-button type="primary" @click="getData('refresh')">查询</el-button>
            </div>
        </pageDialog>
        <div class="fg1 df fdc h14 ml10 mr10">
            <jh-table class="fg1 ova" height="100%" size="small" :stripe="true" row-key="tagApplyId" ref="jhTable" :columnList="columnList"
                      :data="dataList" @selection-change="handleSelectionChange" @deleteData="delData"/>
            <div class="tc pt10 pb10">
                <jh-pager :pager.sync="pager" @getData="getData"/>
            </div>
        </div>
        <infoDialog @onSuccess="getData" :infoDialogConfig="infoDialogConfig" v-if="infoDialogVisible"
                    :infoDialogVisible.sync="infoDialogVisible"/>
        <selectColumnDialog v-model="showSelect" :columnList="allColumnList" :selectCol.sync="selectCol" width="200px"/>
        <handStep :stepDialogConfig="stepDialogConfig" v-if="stepDialogVisible" :stepDialogVisible.sync="stepDialogVisible"></handStep>
    </div>
</template>

<script>
    export default {
        components: {
            infoDialog: (resolve) => resolve(require("./components/infoDialog")),
            handStep: (resolve) => resolve(require("./handStep.vue")),
        },
        data() {
            return {
                stepDialogConfig: {
                    title: "流程处理",
                },
                stepDialogVisible:false,
                bqztList:[],
                bqysList:[],
                bqggList:[],
                pager: {
                    size: 20,
                    total: 0,
                    page: 1,
                },
                showForm: false, //高级搜索
                showSelect: false, //表格动态列
                options: [], //模块数组
                searchForm: {
                    tagApplyId: '',
                    applySqsl: '',
                    tagYs: '',
                    tagGg: '',
                    tagZt: '',
                    applyUserId: '',
                    applyUserName: '',
                    applyTime: '',
                    applyDesc: '',
                    createName: '',
                    createId: '',
                    createTime: '',
                    handFhl: '',
                    handUserId: '',
                    handUserName: '',
                    handTime: '',
                },
                infoDialogVisible: false,
                infoDialogConfig: {
                    title: "添加信息",
                },
                dataRoleTypes: [],
                dataList: [], //表格数据
                selectList: [], //选中数组
                selectCol: [], //选中列
                //表格列数组  不是用动态列可以直接赋值给columnList 不需要computed
                allColumnList: [{
                    type: "selection",
                    align: "center",
                    reserveSelection: true, //与表格的row-key配合使用 实现跨页选中
                },
                    {
                        type: "index",
                        align: "center",
                    },
                    {
                        prop: "tagYsLabel",
                        label: "标签样式",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "tagGgLabel",
                        label: "标签规格",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "applySqsl",
                        label: "申请数量",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "applyUserName",
                        label: "申请人姓名",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "applyTime",
                        label: "申请时间",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "tagZtLabel",
                        label: "状态",
                        align: "center",
                        minWidth: "120px",
                    },
                    {
                        prop: "createTime",
                        label: "创建时间",
                        align: "center",
                        minWidth: "100px",
                        render: (h, scope) => {
                            return h(
                                "div",
                                this.formatDate(scope.row.createTime, "yyyy-MM-dd")
                            );
                        },
                    },
                    {
                        prop: "",
                        fixed: "right",
                        label: "操作",
                        align: "center",
                        width: "120px",
                        renderHeader: (h, scope) => {
                            return h(
                                "div", {
                                    class: {
                                        df: true,
                                        aic: true,
                                        jcb: true,
                                        pl10: true,
                                        pr10: true,
                                    },
                                },
                                [
                                    h("div", {}, []),
                                    h(
                                        "div", {
                                            domProps: {
                                                innerHTML: "操作",
                                            },
                                        },
                                        []
                                    ),
                                    h(
                                        "i", {
                                            class: {
                                                "el-icon-s-operation": true,
                                                poi: true,
                                            },
                                            style: {
                                                fontSize: "20px",
                                            },
                                            on: {
                                                click: () => (this.showSelect = !this.showSelect),
                                            },
                                        },
                                        []
                                    ),
                                ]
                            );
                        },
                        render: (h, scope) => {
                            return h("div", {}, [
                                h("el-button", {
                                    on: {
                                        click: this.editData.bind(this, scope.row),
                                    },
                                    props: {
                                        type: "text",
                                    },
                                    domProps: {
                                        innerHTML: "处理",
                                    },
                                }),
                                // h("el-button", {
                                //     on: {
                                //         click: scope._self.deleteRow.bind(this, scope.row),
                                //     },
                                //     props: {
                                //         type: "text",
                                //     },
                                //     domProps: {
                                //         innerHTML: "删除",
                                //     },
                                // }),
                            ]);
                        },
                    },],
            };
        },
        computed: {
            columnList: function () {
                return this.allColumnList.filter(
                    (item) =>
                        !item.label ||
                        this.selectCol.includes(item.label) ||
                        item.label === "操作"
                );
            },
        },


        async mounted() {
            await this.getEnmuList();
            this.getData();
        },

        created() {
            this.selectCol = this.allColumnList
                .map(item => item.label)
                .filter(item => item && item != "操作");
        },
        methods: {
            handleSelectionChange(row) {
                this.selectList = row;
            },
            batchDelete() {
                if (this.selectList.length === 0) {
                    this.$message.warning("当前未选择数据");
                    return;
                }
                this.$confirm("此操作将永久删除这些项, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let params = [];
                        for (let i = 0; i < this.selectList.length; i++) {
                            params[i] = this.selectList[i].tagApplyId;
                        }
                        this.$api.formPost("/api/major/tag/tagApply/doRmByIds", {
                            ids: params
                        }).then((res) => {
                            this.selectList = [];
                            this.$refs.jhTable.$refs.formTable.clearSelection();
                            this.$message.success("删除成功");
                            this.getData();
                        });
                    })
                    .catch(() => {
                    });
            },

            getData(type) {
                if (type === "refresh") {
                    this.pager.page = 1;
                }
                let params = {
                    pageNum: this.pager.page,
                    pageSize: this.pager.size,
                    ...this.searchForm,
                };
                let load = this.$loading({
                    target: this.$refs.jhTable.$el,
                });
                this.showForm = false;
                this.$api
                    .formPost("/api/major/tag/tagApply/doGetList", params)
                    .then((res) => {
                        if (res.retHead.code == "0000000") {
                            load.close();
                            this.dataList = res.retBody.list;
                            this.dataList.forEach(item => {
                                // 反显标签申请状态
                                if (item.tagZt !== '') {
                                    this.bqztList.forEach(bqzt => {
                                        if (bqzt.codeValue === item.tagZt) {
                                            item.tagZtLabel = bqzt.codeName;
                                        }
                                    })
                                }
                                // 反显标签样式
                                if (item.tagYs !== '') {
                                    this.bqysList.forEach(bqys => {
                                        if (bqys.codeValue === item.tagYs) {
                                            item.tagYsLabel = bqys.codeName;
                                        }
                                    })
                                }
                                // 反显标签规格
                                if (item.tagGg !== '') {
                                    this.bqggList.forEach(bqgg => {
                                        if (bqgg.codeValue === item.tagGg) {
                                            item.tagGgLabel = bqgg.codeName;
                                        }
                                    })
                                }
                            });
                            this.pager.total = res.retBody.total;
                        }
                    })
            },
            // 编辑
            editData(row) {
                this.stepDialogConfig.bqztList = this.bqztList;
                this.stepDialogConfig.bqysList = this.bqysList;
                this.stepDialogConfig.bqggList = this.bqggList;
                // if (row) {
                //     this.infoDialogConfig.title = "修改信息";
                //     this.infoDialogConfig.data = JSON.parse(JSON.stringify(row));
                // } else {
                //     this.infoDialogConfig.title = "添加信息";
                //     this.infoDialogConfig.data = null;
                // }
                this.stepDialogConfig.data = JSON.parse(JSON.stringify(row));

                this.stepDialogVisible = true;
            },
            delData(row) {
                let params = {
                    id: row.tagApplyId,
                };
                this.$api
                    .formPost("/api/major/tag/tagApply/doRmById", params)
                    .then((res) => {
                        this.$message.success("删除成功");
                        this.getData();
                    });
            },
            reset() {
                this.$refs.searchForm.resetFields();
                for (const key in this.searchForm) {
                    this.searchForm[key] = "";
                }
                this.searchForm.compId = JSON.parse(sessionStorage.getItem('user')).organId,
                this.searchForm.organRecurFlag = '1'
                this.currentPage = 1;
                this.getData("refresh");
            },
            initData() {
                this.getData("refresh");
            },
            getEnmuList() {
                return new Promise(resolve => {
                    let params = ["bqzt","bqys","bqgg"];
                    this.$api.formPost("/api/basfun/syscode/query/doGetItemsByCodes", {
                        sysCodes: params.join(",")
                    }).then(res => {
                        if (res.retBody) {
                            params.map(item => {
                                if (item == "bqzt") {
                                    this.bqztList = res.retBody[item];
                                }else if(item == "bqys"){
                                    this.bqysList = res.retBody[item];
                                }else if(item == "bqgg"){
                                    this.bqggList = res.retBody[item];
                                }
                            })
                            resolve();
                        }
                    }).catch(() => {});
                })
            },
        },
    };
</script>

<style lang="scss" scoped>
    .bank {
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tag/tagApplyHand/tagApplyHand.vue